import { Component } from '@angular/core';
import * as Chartist from 'chartist';
import { DashboardService } from '../services/dashboard/dashboard.service';
import { DatePipe } from "@angular/common";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { default as _rollupMoment, Moment, } from 'moment';
import { FormControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { Dashboard } from '../models/Dashboard';
import { environment } from 'environments/environment';


const moment = _rollupMoment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class DashboardComponent {
  Label_Proveedor = environment.LABEL_PROVEEDOR;
  Label_Proveedores = environment.LABEL_PROVEEDORES;
  Label_Adquirente = environment.LABEL_ADQUIRENTE;
  Label_Adquirentes = environment.LABEL_ADQUIRENTES;
  ID_ROL_PRONTOPAGO = environment.ID_ROL_PP;
  flagEspecial: boolean = false;
  date = new FormControl(moment());
  contratos;
  facturas;
  dashboard: Dashboard;
  loading: boolean;
  totalColocaciones: number;
  totalAdelanto: number;
  totalIngreso: number;
  totalCobranza: number;
  totalIngresoOtros: number;

  user: any;
  Codigo: any = "LOGO_EMPRESA";
  ColorSec: any = "COLOR_SECUNDARIO";
  ParametrosList: any;
  ParametroColor: any;
  bgImageUrl: string = "";

  constructor(private dashboardService: DashboardService, private datePipe: DatePipe) {
    this.user = JSON.parse(sessionStorage.getItem("UserActive"));
    this.loading = true;
    this.obtenerDashboard();
    this.obtenerDatosContratos();
    this.obtenerDatosFactura();
    if (this.user.id_roles == this.ID_ROL_PRONTOPAGO) {
      this.flagEspecial = true;
    }
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.obtenerDashboardFecha();
  }

  startAnimationForLineChart(chart) {
    let seq: any, delays: any, durations: any;
    seq = 0;
    delays = 80;
    durations = 500;

    chart.on('draw', function (data) {
      if (data.type === 'line' || data.type === 'area') {
        data.element.animate({
          d: {
            begin: 600,
            dur: 700,
            from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
            to: data.path.clone().stringify(),
            easing: Chartist.Svg.Easing.easeOutQuint
          }
        });
      } else if (data.type === 'point') {
        seq++;
        data.element.animate({
          opacity: {
            begin: seq * delays,
            dur: durations,
            from: 0,
            to: 1,
            easing: 'ease'
          }
        });
      }
    });

    seq = 0;
  }
  startAnimationForBarChart(chart) {
    let seq2: any, delays2: any, durations2: any;

    seq2 = 0;
    delays2 = 80;
    durations2 = 500;
    chart.on('draw', function (data) {
      if (data.type === 'bar') {
        seq2++;
        data.element.animate({
          opacity: {
            begin: seq2 * delays2,
            dur: durations2,
            from: 0,
            to: 1,
            easing: 'ease'
          }
        });
      }
    });

    seq2 = 0;
  }

  alerta() {
    alert('ES GG');
  }


  obtenerDashboardFecha() {
    this.loading = true;

    this.dashboardService.obtenerDatosDashboard(this.datePipe.transform(this.date.value._d, 'yyyyMM')).subscribe(
      res => {
        this.dashboard = res;

        if (this.dashboard == null) {
          this.dashboard = new Dashboard();
        }

        this.totalColocaciones = Number(this.dashboard.VNPP_Soles) + Number(this.dashboard.VNPP_Dolar_a_Soles);
        this.totalAdelanto = Number(this.dashboard.Adelanto_Soles) + Number(this.dashboard.Adelanto_Dolar_a_Soles);
        this.totalCobranza = Number(this.dashboard.Cobranza_soles) + Number(Number(this.dashboard.Cobranza_dolar) * Number(this.dashboard.Tipo_cambio));
        this.totalIngreso = Number(this.dashboard.Ingresos_Soles) + Number(this.dashboard.Ingresos_Dolar_a_Soles);
        this.totalIngresoOtros = Number(this.dashboard.Ingresos_Soles_Otros) + Number(this.dashboard.Ingresos_Dolar_Otros_a_Soles);
        this.loading = false;

      }, error => { this.loading = false; })
  }

  obtenerDashboard() {
    this.enviarTOKEN();
    this.dashboardService.obtenerDatosDashboard(this.datePipe.transform(this.date.value._d, 'yyyyMM'))
      .subscribe(res => {
        this.dashboard = res;
        if (this.dashboard == null) {
          this.dashboard = new Dashboard();
        }

        this.totalColocaciones = Number(this.dashboard.VNPP_Soles) + Number(this.dashboard.VNPP_Dolar_a_Soles);
        this.totalAdelanto = Number(this.dashboard.Adelanto_Soles) + Number(this.dashboard.Adelanto_Dolar_a_Soles);
        this.totalCobranza = Number(this.dashboard.Cobranza_soles) + Number(Number(this.dashboard.Cobranza_dolar) * Number(this.dashboard.Tipo_cambio));
        this.totalIngreso = Number(this.dashboard.Ingresos_Soles) + Number(this.dashboard.Ingresos_Dolar_a_Soles);
        this.totalIngresoOtros = Number(this.dashboard.Ingresos_Soles_Otros) + Number(this.dashboard.Ingresos_Dolar_Otros_a_Soles);

        if (this.facturas != null && this.dashboard != null && this.contratos != null) {

          this.loading = false;
        }

      }, err => {
        this.loading = false;
      })
  }

  obtenerDatosFactura() {
    this.dashboardService.obtenerDatosFacturaDashboard()
      .subscribe(res => {
        this.facturas = res;
        if (this.facturas != null && this.dashboard != null && this.contratos != null) {
          this.loading = false;
        }
      }, err => {
        this.loading = false;
      });
  }

  obtenerDatosContratos() {
    this.dashboardService.obtenerDatosContratosDashboard()
      .subscribe(res => {
        this.contratos = res;
        if (this.facturas != null && this.dashboard != null && this.contratos != null) {
          this.loading = false;
        }
      }, err => {
        this.loading = false;
      });
  }

  desencriptarTOKEN(): any {
    let encriptadoTOKEN = sessionStorage.getItem('Kn48Nki8is9dhan54648asm78f6s3JDF56L4Ndf2SDdas55');
    let arregloTOKEN = encriptadoTOKEN.split('ñ', 10);
    return arregloTOKEN[4];
  }

  enviarTOKEN() {
    this.dashboardService.TOKEN = this.desencriptarTOKEN();
  }
}
